export default __webpack_public_path__ + "static/Samsung_Pay_icon.png";